webpackJsonp([53230496490435],{

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PIPageQuery = exports.PIPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Content = __webpack_require__(17);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PIPageTemplate = exports.PIPageTemplate = function PIPageTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      headshot = _ref.headshot,
	      headerImage = _ref.headerImage,
	      content = _ref.content,
	      contentComponent = _ref.contentComponent;
	
	  var PageContent = contentComponent || _Content2.default;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Header2.default, { title: title, subtitle: subtitle, image: headerImage }),
	    _react2.default.createElement(
	      "section",
	      { className: "section container body" },
	      _react2.default.createElement("img", { id: "pi-headshot", src: headshot, alt: "Principal Investigator Headshot" }),
	      _react2.default.createElement(PageContent, { className: "content", content: content })
	    )
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var post = data.markdownRemark;
	
	
	  return _react2.default.createElement(PIPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: post.frontmatter.title,
	    subtitle: post.frontmatter.subtitle,
	    headerImage: post.frontmatter.headerImage,
	    headshot: post.frontmatter.headshot,
	    content: post.html
	  });
	};
	
	var PIPageQuery = exports.PIPageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-principal-investigator-page-js-2897e344b046e69bc7f6.js